import { render, staticRenderFns } from "./vFormLIST_MATCH_TEXT_INPUT.vue?vue&type=template&id=a843f412&scoped=true&"
import script from "./vFormLIST_MATCH_TEXT_INPUT.vue?vue&type=script&lang=js&"
export * from "./vFormLIST_MATCH_TEXT_INPUT.vue?vue&type=script&lang=js&"
import style0 from "./vFormLIST_MATCH_TEXT_INPUT.vue?vue&type=style&index=0&id=a843f412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a843f412",
  null
  
)

export default component.exports